module.exports = __webpack_public_path__ + "static/media/Alert.50f92260.png";